import React from "react";
import HomeSideNavBar from "../HomeSideNavBar";
import Header from "../Header";
import ApiDataProvider from "../ApiDataContext";
import UserList from "../../features/users/UserList";

/**
 * Users page shell. Replaces the previous List/Register tab layout.
 *
 * The new UserList screen renders its own page header (with the primary
 * "+ New user" CTA) and opens create/edit forms in a SlideOver — so the
 * page-level tabs are no longer needed. Permission gating is preserved
 * inside UserList (canRegister, canEdit, canSuspend, etc.).
 */
function Users() {
  return (
    <ApiDataProvider>
      <div className="container">
        <div className="screen-layout">
          <Header />
          <HomeSideNavBar />

          {/* The Users page surface; flex column owns the page layout */}
          <main className="flex-1 min-w-0 min-h-0 flex flex-col bg-surface-muted overflow-y-auto">
            <UserList />
          </main>
        </div>
      </div>
    </ApiDataProvider>
  );
}

export default Users;
